import Vue from 'vue'

export function tree(data) {
    return Vue.axios({
        url: '/api/organization/tree',
        method: 'get',
        params: {...data}
    })
}

export function store(data) {
    return Vue.axios({
        url: '/api/organization/store',
        method: 'post',
        params: {...data}
    })
}

export function options(data) {
    return Vue.axios({
        url: '/api/organization/options',
        method: 'get',
        params: {...data}
    })
}

export function del(data) {
    return Vue.axios({
        url: '/api/organization/delete',
        method: 'get',
        params: {...data}
    })
}

export function detail(params) {
    return Vue.axios({
        url: '/api/organization/detail',
        method: 'get',
        params
    })
}